import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

/** Toast + bouton Rejoindre quand un joueur reçoit une invitation en ligne. */
export function useGameInviteNotifications() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const seenRef = useRef(new Set());

  useEffect(() => {
    const uid = user?.id;
    if (!uid) return;

    const check = async () => {
      try {
        const { data } = await api.get("/games/online/invites");
        for (const inv of data || []) {
          if (seenRef.current.has(inv.room_id)) continue;
          seenRef.current.add(inv.room_id);
          toast.success(`${inv.host_name} vous invite à une partie !`, {
            duration: 12000,
            action: {
              label: "Rejoindre",
              onClick: () => navigate(`/game/online/${inv.room_id}`),
            },
          });
        }
      } catch {
        /* ignore */
      }
    };

    check();
    const id = setInterval(check, 5000);
    return () => clearInterval(id);
  }, [user?.id, navigate]);
}
